(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vc-product-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vc-review-slider')) {
    customElements.define('vc-review-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.cards = [...this.track.children];
        this.previous = this.querySelector('[data-review-prev]');
        this.next = this.querySelector('[data-review-next]');
        this.position = this.querySelector('[data-review-position]');
        this.controls = this.querySelector('[data-review-controls]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      move(direction) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = this.cards[0].getBoundingClientRect().width + gap;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({ left: direction * step * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      update() {
        const bounds = this.track.getBoundingClientRect();
        const visible = this.cards.map((card, index) => ({ index, rect: card.getBoundingClientRect() })).filter(({ rect }) => Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) > rect.width * 0.6);
        const first = visible[0]?.index ?? 0;
        const last = visible[visible.length - 1]?.index ?? first;
        const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        this.controls.hidden = !overflow;
        this.previous.disabled = Math.abs(this.track.scrollLeft) < 2;
        this.next.disabled = Math.abs(this.track.scrollLeft) >= this.track.scrollWidth - this.track.clientWidth - 2;
        this.position.textContent = `${first + 1}${last > first ? '–' + (last + 1) : ''} / ${this.cards.length}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vc-product')) {
    customElements.define('vc-product', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.addEventListener('click', event => {
          const thumb = event.target.closest('[data-thumb]');
          if (thumb) this.showMedia(thumb.dataset.thumb);
          const control = event.target.closest('[data-quantity]');
          if (control) {
            const input = this.querySelector('[name="quantity"]');
            if (!input.value || !input.checkValidity()) input.value = input.min || 1;
            if (control.dataset.quantity === '1') input.stepUp(); else input.stepDown();
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        this.addEventListener('change', event => { if (event.target.matches('[data-option]')) this.changeVariant(event.target); });
        this.bindSticky();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); this.ready = false; }
      showMedia(id) {
        this.querySelectorAll('[data-media]').forEach(panel => {
          panel.hidden = panel.dataset.media !== String(id);
          if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
          if (panel.hidden) panel.querySelectorAll('iframe').forEach(frame => {
            frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), '*');
            frame.contentWindow?.postMessage(JSON.stringify({method:'pause'}), '*');
          });
        });
        this.querySelectorAll('[data-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.thumb === String(id))));
      }
      bindSticky() {
        const bar = this.querySelector('[data-sticky]');
        if (!bar) return;
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          bar.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
        }, { threshold: 0 });
        this.observer.observe(this.querySelector('.vcp-purchase-row'));
      }
      async changeVariant(select) {
        const targetUrl = select.selectedOptions[0].dataset.productUrl;
        if (targetUrl && new URL(targetUrl, location.origin).pathname !== new URL(this.dataset.productUrl, location.origin).pathname) { location.assign(targetUrl); return; }
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        const url = new URL(location.href);
        url.searchParams.delete('variant');
        url.searchParams.set('option_values', [...this.querySelectorAll('[data-option]')].map(el => el.value).join(','));
        const quantity = this.querySelector('[name="quantity"]').value;
        const position = select.dataset.position;
        this.setAttribute('aria-busy', 'true');
        this.querySelector('.vcp-add').disabled = true;
        this.querySelector('[name="id"]').disabled = true;
        this.querySelector('.vcp-express')?.setAttribute('hidden', '');
        this.querySelector('[data-status]').textContent = this.querySelector('[data-updating]').textContent;
        const requestUrl = new URL(url);
        requestUrl.searchParams.set('section_id', this.dataset.section);
        try {
          const response = await fetch(requestUrl, { signal: controller.signal });
          if (!response.ok) throw new Error('variant');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (controller.signal.aborted) return;
          const box = doc.querySelector('[data-buybox]');
          if (!box) throw new Error('variant');
          this.querySelector('[data-buybox]').replaceWith(box);
          const quantityInput = this.querySelector('[name="quantity"]');
          quantityInput.value = quantity;
          if (!quantityInput.checkValidity()) quantityInput.value = quantityInput.min || 1;
          if (box.dataset.featured) this.showMedia(box.dataset.featured);
          const stickyPrice = this.querySelector('[data-sticky-price]');
          if (stickyPrice) stickyPrice.textContent = box.querySelector('.vcp-pricing strong').textContent;
          const variant = box.querySelector('[name="id"]').value;
          if (variant) { url.searchParams.delete('option_values'); url.searchParams.set('variant', variant); }
          history.replaceState({}, '', url);
          this.querySelector('[data-option][data-position="' + position + '"]')?.focus({preventScroll:true});
          this.bindSticky();
          window.Shopify?.PaymentButton?.init();
        } catch (error) {
          if (error.name !== 'AbortError') location.assign(url);
        } finally {
          if (this.controller === controller) this.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
